function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { kebabCase } from 'lodash';

// Platform-default Export All for web form cabinets is resolved here before the Actions
// menu renders. Cabinets can opt out (cabinetCsvExport: false), rely on the default inject
// (no export entry in csv), or override fields via an explicit actionsMenuItems entry matched
// by id 'cabinetCsvExport' or cabinetCsvExportRequestBehavior (see rb defaultOptions for
// allow_form_edit override and rb examples for allow_form_view_detail override).

export const CABINET_CSV_EXPORT_BEHAVIOR = 'cabinetCsvExportRequestBehavior';
export const CABINET_CSV_EXPORT_ID = 'cabinetCsvExport';
export const buildDefaultCabinetCsvExportMenuItem = () => ({
  id: CABINET_CSV_EXPORT_ID,
  title: 'Export All',
  permission: 'ownerPermission',
  icon: 'download',
  style: 'default',
  requiresSelection: false,
  actions: [{
    type: CABINET_CSV_EXPORT_BEHAVIOR
  }]
});
export const isCabinetCsvExportMenuItem = item => {
  if (!item) {
    return false;
  }
  if (item.id === CABINET_CSV_EXPORT_ID) {
    return true;
  }
  return Array.isArray(item.actions) && item.actions.some(action => (action === null || action === void 0 ? void 0 : action.type) === CABINET_CSV_EXPORT_BEHAVIOR);
};
export const isCabinetCsvExportOptedOut = (explicitItem, cabinetDefinition = {}) => {
  if (cabinetDefinition.cabinetCsvExport === false) {
    return true;
  }
  if ((explicitItem === null || explicitItem === void 0 ? void 0 : explicitItem.enabled) === false) {
    return true;
  }
  return false;
};
export const isCabinetEligibleForCsvExport = (cabinetDefinition = {}) => {
  var _web$layout;
  const {
    formTypeIdentifiers = [],
    directFormType,
    client
  } = cabinetDefinition;
  const web = client === null || client === void 0 ? void 0 : client.web;
  if (directFormType) {
    return false;
  }
  if (!web) {
    return false;
  }
  if ((_web$layout = web.layout) !== null && _web$layout !== void 0 && _web$layout.superset) {
    return false;
  }
  if (!Array.isArray(formTypeIdentifiers) || formTypeIdentifiers.length === 0) {
    return false;
  }
  return true;
};
export const mergeCabinetCsvExportMenuItem = (explicit = {}) => {
  const defaults = buildDefaultCabinetCsvExportMenuItem();
  // Explicit csv fields (e.g. permission: 'allow_form_edit') override defaults; behavior
  // wiring falls back to cabinetCsvExportRequestBehavior when actions is omitted.
  return _objectSpread(_objectSpread(_objectSpread({}, defaults), explicit), {}, {
    actions: Array.isArray(explicit.actions) && explicit.actions.length ? explicit.actions : defaults.actions
  });
};
const insertDefaultExportMenuItem = items => {
  const defaultItem = buildDefaultCabinetCsvExportMenuItem();
  const deleteIndex = items.findIndex(item => {
    var _item$action;
    return ((_item$action = item.action) === null || _item$action === void 0 ? void 0 : _item$action.type) === 'bulkDelete' || kebabCase(item.title || '') === 'delete';
  });
  if (deleteIndex >= 0) {
    return [...items.slice(0, deleteIndex), defaultItem, ...items.slice(deleteIndex)];
  }
  return [...items, defaultItem];
};
export const resolveCabinetActionsMenuItems = ({
  actionsMenuItems,
  cabinetDefinition: _cabinetDefinition = {}
}) => {
  const items = Array.isArray(actionsMenuItems) ? [...actionsMenuItems] : [];
  const explicitIndex = items.findIndex(isCabinetCsvExportMenuItem);
  const explicitItem = explicitIndex >= 0 ? items[explicitIndex] : null;
  if (isCabinetCsvExportOptedOut(explicitItem, _cabinetDefinition)) {
    return items.filter(item => !isCabinetCsvExportMenuItem(item));
  }
  if (explicitItem) {
    const merged = mergeCabinetCsvExportMenuItem(explicitItem);
    const result = [...items];
    result[explicitIndex] = merged;
    return result;
  }
  if (!isCabinetEligibleForCsvExport(_cabinetDefinition)) {
    return items;
  }
  return insertDefaultExportMenuItem(items);
};
export default resolveCabinetActionsMenuItems;